import React from 'react';
import styled from 'styled-components';

interface WhatsAppLogoutDialogProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const Overlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${props => props.isOpen ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  z-index: 99999;
`;

const DialogBox = styled.div`
  background: #ffffff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 400px;
  position: relative;
  z-index: 100000;
`;

const Title = styled.h3`
  color: #333;
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
`;

const Message = styled.p`
  color: #666;
  margin-bottom: 24px;
  font-size: 16px;
  text-align: center;
  line-height: 1.5;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
`;

const Button = styled.button<{ primary?: boolean }>`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
  
  ${props => props.primary ? `
    background: #FF4D00;
    color: white;
    border: none;
    
    &:hover {
      background: #E64500;
    }
  ` : `
    background: white;
    color: #333;
    border: 1px solid #ddd;
    
    &:hover {
      background: #f5f5f5;
    }
  `}
`;

const WhatsAppLogoutDialog: React.FC<WhatsAppLogoutDialogProps> = ({
    isOpen,
    onConfirm,
    onCancel
}) => {
    return (
        <Overlay isOpen={isOpen} onClick={onCancel}>
            <DialogBox onClick={e => e.stopPropagation()}>
                <Title>Logout from WhatsApp?</Title>
                <Message>Are you sure you want to logout from WhatsApp on this device? This will disconnect your WhatsApp account from the system, but you will remain logged in to your app account.</Message>
                <ButtonGroup>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button primary onClick={onConfirm}>Yes, Logout</Button>
                </ButtonGroup>
            </DialogBox>
        </Overlay>
    );
};

export default WhatsAppLogoutDialog; 